import BaseAPI, { querySuffix } from "./BaseAPI";
import { getAPIUrlV2 } from "../apiConfig";
import { stockRoute } from "../routes";

export default class StockAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, stockRoute, "stock");
    }

    async AttachBarcode(id, barcode) {
        const result = await this._request("put", this._url(`/${id}/barcodes`), { barcode });
        this._emit("update", id);
        return result;
    }

    async ResolveBarcode(barcode) {
        return this._request("get", this._url(querySuffix({ barcode })));
    }

    async Balances(params = {}) {
        return this._request("get", this._url(`/balances${querySuffix(params)}`));
    }

    async GetIntakesArrayFromStockIDs(stockIDs) {
        return this._request("get", `${getAPIUrlV2("intakes")}?stock-ids=${stockIDs.join(",")}`);
    }

    async MarkOutOfStock(id) {
        const result = await this._request("put", this._url(`/${id}/out-of-stock`));
        this._emit("mark-out-of-stock", id);
        return result;
    }

    async MarkArchived(id) {
        const result = await this._request(
            "post",
            `${getAPIUrlV2("control/stocks")}/mark-archived?id=${id}`
        );
        this._emit("mark-archived", id);
        return result;
    }

    async UnmarkArchived(id) {
        const result = await this._request("delete", this._url(`/${id}/archive`));
        this._emit("unmark-archived", id);
        return result;
    }

    async MarkRecalled(id) {
        const result = await this._request("put", this._url(`/${id}/recall`));
        this._emit("mark-recalled", id);
        return result;
    }
}
